export default __webpack_public_path__ + "static/media/arras16.fce9a32b.jpg";